// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"29024415","703":"dfd29213","787":"94527a66"}[chunkId] + ".chunk.js";
};